<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<script setup>
import { computed, onMounted, ref, watch } from 'vue';

const props = defineProps({
  state: { type: String },
  isActive: {
    type: Boolean,
    default: false,
  },
  stateObj: { type: Object },
});

const localStartPhase = ref(0);
const localEndPhase = ref(0);

const BmoreStartPhase = computed({
  get: () => props.stateObj.getSalientPhaseLocation('BMORE0') + 1,
  set: value => props.stateObj.setSalientPhaseLocation('BMORE0', value - 1),
});

const BmoreEndPhase = computed({
  get: () => props.stateObj.getSalientPhaseLocation('BMORE30') + 1,
  set: value => props.stateObj.setSalientPhaseLocation('BMORE30', value - 1),
});

const startPhase = computed(() => props.stateObj.getStart());
const endPhase = computed(() => props.stateObj.getEnd());

const numPhases = computed(() => endPhase.value - startPhase.value + 1);

onMounted(() => {
  localStartPhase.value = startPhase.value + 1;
  localEndPhase.value = endPhase.value + 1;
});

watch(
  () => [startPhase.value, endPhase.value],
  ([newStart, newEnd]) => {
    localStartPhase.value = newStart + 1;
    localEndPhase.value = newEnd + 1;
  },
);

const updatePhaseLocation = () => {
  props.stateObj.updateStartEnd(
    localStartPhase.value - 1,
    localEndPhase.value - 1,
  );

  // Check if BMORE falls outside the new range and adjust if necessary
  if (
    BmoreStartPhase.value < localStartPhase.value
    || BmoreStartPhase.value > localEndPhase.value
  ) {
    props.stateObj.setSalientPhaseLocation('BMORE0', localStartPhase.value - 1);
  }
  if (
    BmoreEndPhase.value < localStartPhase.value
    || BmoreEndPhase.value > localEndPhase.value
  ) {
    props.stateObj.setSalientPhaseLocation('BMORE30', localEndPhase.value - 1);
  }
  // localStartPhase.value = startPhase.value + 1;
  // localEndPhase.value = endPhase.value + 1;
};
</script>

<template>
  <div
    class="custom-button simple-panel px-2 py-1"
    @click="handleClick"
    @keydown.space.prevent="handleKeyDown"
  >
    <div class="button-content">
      <div class="flex align-center gap-2">
        <h4 :style="{ color: stateObj.color }">
          {{ state }}
        </h4>
        <h6>({{ numPhases }} phases)</h6>
      </div>
      <div class="flex gap-4">
        <div class="phase-location-inputs">
          <div class="input-group">
            <h6 for="startPhaseLocation">
              Start/End:
            </h6>
            <input
              v-model="localStartPhase"
              type="number"
              class="general-input"
            >
            /
            <input
              v-model="localEndPhase"
              type="number"
              class="general-input"
            >
          </div>
          <button class="btn-outline-simple" @click="updatePhaseLocation">
            <h6>Update</h6>
          </button>
        </div>

        <div class="phase-location-inputs">
          <div class="input-group">
            <h6 for="startPhaseLocation">
              BMORE(0/30):
            </h6>
            <input
              v-model="BmoreStartPhase"
              type="number"
              class="general-input"
            >
            /
            <input
              v-model="BmoreEndPhase"
              type="number"
              class="general-input"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-button {
  cursor: pointer;
  border-radius: 0;
  box-sizing: border-box;
  width: 100%;
}

.button-content {
  display: flex;
  flex-direction: column;
}

.row-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.phase-location-inputs {
  margin-top: 5px;
  display: flex;
  gap: 5px;
}

.input-group {
  display: flex;
  align-items: center;
  gap: 1px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.input-group input {
  margin-left: 5px;
  width: 40px;
  padding: 1px 2px;
  font-size: 12px;
  text-align: right;
  outline: none;
  border-radius: 5px;
}
</style>
